import { Link } from "react-router-dom";
import { Logo, title } from "../Config";
import { LocalWebLink } from "../Config/constants";

const Footer = () => {


     const footerLinks = [
          ...LocalWebLink,
          {
               name: 'Partner',
               icon: '',
               linkUrl: 'https://thedc-xi.vercel.app/',
               link: true,
               target: true
          }
     ];

     return (
          <footer className="footer">
               <div className="content-center">
                    <div className="row">

                         <div className="col-12">
                              <div className="footer-logo">
                                   <img src={Logo} alt="Logo" width="120" />
                                   <p>We specialize in building fast, scalable, and intuitive mobile apps.
                                        With React Native, we deliver seamless cross-platform experiences.
                                        Our focus is on performance, design, and user satisfaction.
                                        Let’s bring your ideas to life with cutting-edge mobile solutions.</p>

                              </div>
                         </div>

                         <div className="col-12">
                              <div className="__links-data">
                                   <ul className="footer-links">
                                        {footerLinks.map((item, index) => (
                                             <li key={index}>
                                                  {item.link ?
                                                       item.target ?
                                                            <Link to={item.linkUrl} target="_blank" className="text-light">{item.name}</Link>
                                                            :
                                                            <Link to={item.linkUrl} className="text-light">{item.name}</Link>
                                                       :
                                                       <a href={item.linkUrl} className="text-light">{item.name}</a>
                                                  }
                                             </li>
                                        ))}
                                   </ul>
                              </div>
                         </div>
                    </div>
               </div>

               <div className='copy-right'>
                    <p> Copyright © {new Date().getFullYear()} {title}. All Rights Reserved. </p>
               </div>
          </footer>
     );
};

export default Footer;
